export default function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_pipe.js
// module id = 2546
// module chunks = 1